<button [id]="idVal" type="button" (click)="this.scrollToTop()" class="btn st-button-back-to-top rounded-pill">
  <i class="bi bi-arrow-up st-button-icon"></i>
    {{label}}
</button>
